import Home from '../components/pages/home/Home';
import NotFound from '../components/pages/404/NotFound';
import Login from '../components/pages/login/Login';
import Recover from '../components/pages/forgotpassword/Recover';
import Reset from '../components/pages/forgotpassword/Reset';
import Register from '../components/pages/register/Register';
import UpdatePass from '../components/pages/updatepass/UpdatePass';
import Profile from '../components/pages/profile/Profile';
import Users from '../components/pages/users/Users';
import Operators from '../components/pages/operators/Operators';
import SafetyForm from '../components/pages/safety-form/SafetyForm';
import DocumentUpload from '../components/pages/document-upload/DocumentUpload';
import ServerConfig from '../components/pages/server-config/ServerConfig';
import UploadHistory from '../components/pages/document-upload/UploadHistory';
import AmaRouteValidation from '../components/pages/ama/AmaRouteValidation';
import AmaHolidays from '../components/pages/ama/AmaHolidays';
import AmaDashboard from '../components/pages/ama/AmaDashboard';
import HmsTrips from '../components/pages/hms/HmsTrips';
import HmsNtd from '../components/pages/hms/HmsNtd';
import FileProcesses from '../components/pages/fileprocesses/FileProcesses';

import TransdevFareboxCollectionSubmissions from '../components/pages/transdev/FareboxCollectionSubmissions';
import TransdevIncidentals from '../components/pages/transdev/TransdevIncidentals';
import TransdevLaw123 from '../components/pages/transdev/TransdevLaw123';
import TransdevSpecialServices from '../components/pages/transdev/TransdevSpecialServices';
import TransdevTrips from '../components/pages/transdev/TransdevTrips';
import TransdevInvoicesCompare from '../components/pages/transdev/TransdevInvoicesCompare';

import SonnellFareboxCollectionSubmissions from '../components/pages/sonnell/FareboxCollectionSubmissions';
import SonnellIncidentals from '../components/pages/sonnell/SonnellIncidentals';
import SonnellLaw123 from '../components/pages/sonnell/SonnellLaw123';
import SonnellSpecialServices from '../components/pages/sonnell/SonnellSpecialServices';
import SonnellTrips from '../components/pages/sonnell/SonnellTrips';
import SonnellInvoicesCompare from '../components/pages/sonnell/SonnellInvoicesCompare';
import Analytics from '../components/pages/dashboard/Analytics';
import PipelineHealth from '../components/pages/pipeline-health/PipelineHealth';
import AnnotationTest from '../components/pages/dev/AnnotationTest';
import HeatmapTest from '../components/pages/dev/HeatmapTest';

const routes = [
    {
      id: 'login',
      name: 'login',
      path: '/',
      exact: true,
      protected: false,
      component: Login,
    },
    {
      id: 'recover',
      name: 'recover',
      path: '/recover',
      exact: true,
      protected: false,
      component: Recover,
    },
    {
      id: 'reset',
      name: 'reset',
      path: '/reset:id/:token',
      exact: true,
      protected: false,
      component: Reset,
    },
    {
      id: 'register',
      name: 'register',
      path: '/register',
      exact: true,
      protected: false,
      component: Register,
    },
    {
      id: 'home',
      name: 'home',
      path: '/home',
      exact: true,
      protected: false,
      component: Home,
    },
    {
      id: 'profile',
      name: 'profile',
      path: '/profile',
      exact: true,
      protected: false,
      component: Profile,
    },
    {
      id: 'serverconfig',
      name: 'serverconfig',
      path: '/serverconfig',
      exact: true,
      protected: false,
      component: ServerConfig,
    },
    {
      id: 'operators',
      name: 'operators',
      path: '/operators',
      exact: true,
      protected: false,
      component: Operators,
    },
    {
      id: 'users',
      name: 'users',
      path: '/users',
      exact: true,
      protected: false,
      component: Users,
    },
    {
      id: 'document-upload',
      name: 'document-upload',
      path: '/document-upload',
      exact: true,
      protected: false,
      component: DocumentUpload,
    },
    {
      id: 'upload-history',
      name: 'upload-history',
      path: '/upload-history',
      exact: true,
      protected: false,
      component: UploadHistory,
    },
    {
      id: 'safety-form',
      name: 'safety-form',
      path: '/safety-form',
      exact: true,
      protected: false,
      component: SafetyForm,
    },
    {
      id: 'updatepass',
      name: 'updatepass',
      path: '/updatepass',
      exact: true,
      protected: false,
      component: UpdatePass,
    },
    {
      id: 'hmstrips',
      name: 'hmstrips',
      path: '/hms/trips',
      exact: true,
      protected: false,
      component: HmsTrips,
    },
    {
      id: 'hmsntd',
      name: 'hmsntd',
      path: '/hms/ntd',
      exact: true,
      protected: false,
      component: HmsNtd,
    },
    {
      id: 'amaroutevalidation',
      name: 'amaroutevalidation',
      path: '/ama/routevalidation',
      exact: true,
      protected: false,
      component: AmaRouteValidation,
    },
    {
      id: 'amaholidays',
      name: 'amaholidays',
      path: '/ama/holidays',
      exact: true,
      protected: false,
      component: AmaHolidays,
    },
    {
      id: 'amadashboard',
      name: 'amadashboard',
      path: '/ama/dashboard',
      exact: true,
      protected: false,
      component: AmaDashboard
    },
    {
      id: 'transdevtrips',
      name: 'transdevtrips',
      path: '/transdev/trips',
      exact: true,
      protected: false,
      component: TransdevTrips,
    },
    {
      id: 'transdevinvoices',
      name: 'transdevinvoices',
      path: '/transdev/invoice',
      exact: true,
      protected: false,
      component: TransdevInvoicesCompare,
    },
    {
      id: 'transdevinvoicescompare',
      name: 'transdevinvoicescompare',
      path: '/transdev/invoices/compare',
      exact: true,
      protected: false,
      component: TransdevInvoicesCompare,
    },
    {
      id: 'transdevfareboxcollection',
      name: 'transdevfareboxcollection',
      path: '/transdev/farebox',
      exact: true,
      protected: false,
      component: TransdevFareboxCollectionSubmissions
    },
    {
      id: 'transdevIncidentals',
      name: 'transdevIncidentals',
      path: '/transdev/incidentals',
      exact: true,
      protected: false,
      component: TransdevIncidentals
    },
    {
      id: 'transdevlaw123',
      name: 'transdevlaw123',
      path: '/transdev/law123',
      exact: true,
      protected: false,
      component: TransdevLaw123
    },
    {
      id: 'transdevspecialservices',
      name: 'transdevspecialservices',
      path: '/transdev/specialservices',
      exact: true,
      protected: false,
      component: TransdevSpecialServices
    },
    {
      id: 'fileprocesses',
      name: 'fileprocesses',
      path: '/fileprocesses',
      exact: true,
      protected: false,
      component: FileProcesses,
    },
    {
      id: 'sonnelltrips',
      name: 'sonnelltrips',
      path: '/sonnell/trips',
      exact: true,
      protected: false,
      component: SonnellTrips,
    },
    {
      id: 'sonnellinvoices',
      name: 'sonnellinvoices',
      path: '/sonnell/invoice',
      exact: true,
      protected: false,
      component: SonnellInvoicesCompare,
    },
    {
      id: 'sonnellinvoicescompare',
      name: 'sonnellinvoicescompare',
      path: '/sonnell/invoices/compare',
      exact: true,
      protected: false,
      component: SonnellInvoicesCompare,
    },
    {
      id: 'sonnellfareboxcollection',
      name: 'sonnellfareboxcollection',
      path: '/sonnell/farebox',
      exact: true,
      protected: false,
      component: SonnellFareboxCollectionSubmissions
    },
    {
      id: 'sonnellIncidentals',
      name: 'sonnellIncidentals',
      path: '/sonnell/incidentals',
      exact: true,
      protected: false,
      component: SonnellIncidentals
    },
    {
      id: 'sonnelllaw123',
      name: 'sonnelllaw123',
      path: '/sonnell/law123',
      exact: true,
      protected: false,
      component: SonnellLaw123
    },
    {
      id: 'sonnellspecialservices',
      name: 'sonnellspecialservices',
      path: '/sonnell/specialservices',
      exact: true,
      protected: false,
      component: SonnellSpecialServices
    },
    {
      id: 'dashboard',
      name: 'dashboard',
      path: '/dashboard/analytics',
      exact: true,
      protected: false,
      component: Analytics
    },
    {
      id: 'pipelinehealth',
      name: 'pipelinehealth',
      path: '/pipeline-health',
      exact: true,
      protected: false,
      component: PipelineHealth
    },
    {
      id: 'annotationtest',
      name: 'annotationtest',
      path: '/dev/annotation-test',
      exact: true,
      protected: false,
      component: AnnotationTest
    },
    {
      id: 'heatmaptest',
      name: 'heatmaptest',
      path: '/dev/heatmap-test',
      exact: true,
      protected: false,
      component: HeatmapTest
    },
    /* Error route */
    {
      id: '404',
      name: 'Not Found',
      path: '*',
      exact: true,
      protected: false,
      component: NotFound,
    },
]; 

export default routes;
